import type { SessionResponseDto } from "@madamuh/domain";

function normalizePathname(pathnameOrUrl: string): string {
  try {
    return new URL(pathnameOrUrl, "https://madamuhlesson.local").pathname;
  } catch {
    return pathnameOrUrl.split("?")[0]?.split("#")[0] ?? pathnameOrUrl;
  }
}

export function canUseFamilyMode(session: SessionResponseDto | null): boolean {
  return Boolean(
    (session?.member?.roles.includes("parent") || session?.member?.roles.includes("student"))
    && session?.familyAccessState === "available"
  );
}

export function canUseOperatorMode(session: SessionResponseDto | null): boolean {
  return Boolean(
    session?.member?.roles.includes("teacher") || session?.member?.roles.includes("admin")
  );
}

export function canUseAdminMode(session: SessionResponseDto | null): boolean {
  return Boolean(session?.member?.roles.includes("admin"));
}

export function isCurrentRouteAllowedForSession(pathname: string, session: SessionResponseDto | null): boolean {
  if (!session) {
    return false;
  }

  const normalizedPathname = normalizePathname(pathname);
  const tenantPrefix = `/t/${session.tenant.tenantSlug}`;

  if (!normalizedPathname.startsWith(tenantPrefix)) {
    return false;
  }

  if (normalizedPathname.startsWith(`${tenantPrefix}/teacher/admin`)) {
    return canUseAdminMode(session);
  }

  if (normalizedPathname.startsWith(`${tenantPrefix}/teacher`)) {
    return canUseOperatorMode(session);
  }

  if (
    normalizedPathname === `${tenantPrefix}/home`
    || normalizedPathname === `${tenantPrefix}/my-schedule`
    || normalizedPathname === `${tenantPrefix}/notifications`
    || normalizedPathname.startsWith(`${tenantPrefix}/students/`)
    || normalizedPathname === `${tenantPrefix}/member-communications`
    || normalizedPathname.startsWith(`${tenantPrefix}/member-communications/`)
    || normalizedPathname === `${tenantPrefix}/videos`
    || normalizedPathname.startsWith(`${tenantPrefix}/videos/`)
  ) {
    return canUseFamilyMode(session);
  }

  return true;
}
